import { get } from '../api.service';

export interface StatementsRecord {
    totalTax: number;
    socialFee: number;
    grossSalary: number;
    fakturaFee: number;
    salary: number;
    janMonthHours: number;
    febMonthHours: number;
    marMonthHours: number;
    aprMonthHours: number;
    mayMonthHours: number;
    juneMonthHours: number;
    julyMonthHours: number;
    augMonthHours: number;
    septMonthHours: number;
    octMonthHours: number;
    novMonthHours: number;
    decMonthHours: number;
}

export interface StatementsParams {
    year?: string;
}

export interface StatementsResponse {
    statusCode: number;
    message: string;
    response: StatementsRecord;
}

/**
 * Fetches salary statements for a given year.
 * Corresponds to: GET /api/Salary/controldata
 * @param params - The request parameters containing year.
 * @returns The API response with statements data.
 */
export const fetchStatements = async (
    params: StatementsParams = {}
): Promise<StatementsResponse> => {
    try {
        const queryParams: any = {};
        
        if (params.year) {
            queryParams.year = params.year;
        }
        
        const response = await get('/Salary/controldata', queryParams);
        return response;
    } catch (error) {
        console.error('Error fetching salary statements:', error);
        throw error;
    }
};